(function() {
    'use strict';

    angular.module('app.tiposAccionPersonal', []);
})();
